// @ts-ignore
import {collectorsBaseUrl} from "./general";

export const googleAdsUrl = `${collectorsBaseUrl}/google-ads`;

// endpoints
export const googleAdsConnectUrl = `${googleAdsUrl}/oauth`;
